package cc.bluepeak.clubmanager.site.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.components.widgets.LineTag
import cc.bluepeak.clubmanager.site.styles.CardStyle
import cc.bluepeak.clubmanager.site.styles.PaddedCardStyle
import cc.bluepeak.clubmanager.site.styles.Theme
import cc.bluepeak.clubmanager.site.styles.UnderlinedInputVariant
import cc.bluepeak.clubmanager.site.styles.UnderlinedTextAreaStyle
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.components.icons.lucide.LucideCheck
import com.varabyte.kobweb.silk.components.icons.lucide.LucideLifeBuoy
import com.varabyte.kobweb.silk.components.icons.lucide.LucideMail
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.required
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.fetch.CORS
import org.w3c.fetch.Headers
import org.w3c.fetch.MANUAL
import org.w3c.fetch.NO_CACHE
import org.w3c.fetch.RequestCache
import org.w3c.fetch.RequestCredentials
import org.w3c.fetch.RequestInit
import org.w3c.fetch.RequestMode
import org.w3c.fetch.RequestRedirect
import org.w3c.fetch.SAME_ORIGIN
import kotlin.time.Duration.Companion.seconds

@Composable
fun ContactSection() {
    SimpleGrid(
        numColumns(1, 2), PaddedCardStyle.toModifier().fillMaxWidth()
            .gap(1.cssRem)
            .backgroundImage(url("""/${Res.string.locale}/${Res.image.fabric2}"""))
            .background {
                size(BackgroundSize.Cover)
                position(BackgroundPosition.of(CSSPosition.Center))
            }) {
        Column {
            LineTag(Res.string.contact_tag, Modifier.color(Theme.white))
            H1(Modifier.whiteSpace(WhiteSpace.BreakSpaces).color(Theme.white).width(Width.MaxContent).toAttrs()) {
                Text(Res.string.contact_title)
            }
            Spacer()
            Column(verticalArrangement = Arrangement.spacedBy(1.cssRem)) {
                Row(
                    CardStyle.toModifier().padding(1.cssRem),
                    horizontalArrangement = Arrangement.spacedBy(2.cssRem),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    LucideMail(size = 2.cssRem)
                    Column {
                        SpanText(Res.string.email_address, Modifier.fontWeight(600).fontSize(1.1.cssRem))
                        Link(
                            "mailto:${Res.string.clubmanager_email}",
                            Res.string.clubmanager_email,
                            variant = UncoloredLinkVariant,
                            modifier = Modifier.textDecorationLine(TextDecorationLine.Underline)
                        )
                    }
                }
                Row(
                    CardStyle.toModifier().padding(1.cssRem).styleModifier {
                        property("width", "stretch")
                    }, horizontalArrangement = Arrangement.spacedBy(2.cssRem),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    LucideLifeBuoy(size = 2.cssRem)
                    Column {
                        SpanText(Res.string.helpdesk, Modifier.fontWeight(600).fontSize(1.1.cssRem))
                        Link(
                            Res.link.supportForm, Res.string.click_here, variant = UncoloredLinkVariant,
                            modifier = Modifier.textDecorationLine(TextDecorationLine.Underline)
                        )
                    }
                }
            }
        }
        Column(PaddedCardStyle.toModifier()) {
            H2(Modifier.margin(bottom = 1.cssRem).toAttrs()) {
                Text(Res.string.contact_title)
            }
            SpanText(Res.string.contact_form_name)
            var name by remember { mutableStateOf("") }
            TextInput(
                name, { name = it }, variant = UnderlinedInputVariant, placeholder = Res.string.contact_form_name,
                modifier = Modifier.fillMaxWidth().margin(bottom = 1.cssRem),
                required = true
            )
            SpanText(Res.string.contact_form_email)
            var email by remember { mutableStateOf("") }
            Input(
                InputType.Email,
                email,
                { email = it },
                placeholder = Res.string.email_placeholder,
                variant = UnderlinedInputVariant,
                modifier = Modifier.fillMaxWidth().margin(bottom = 1.cssRem),
                required = true
            )
            SpanText(Res.string.contact_form_message)
            var message by remember { mutableStateOf("") }
            TextArea(
                message,
                UnderlinedTextAreaStyle.toModifier().fillMaxWidth().minHeight(5.cssRem).margin(bottom = 1.cssRem)
                    .toAttrs {
                        placeholder(Res.string.contact_form_message)
                        onInput { message = it.value }
                        required()
                    })
            val scope = rememberCoroutineScope()
            var sent by remember { mutableStateOf(false) }
            Button(
                onClick = {
                    scope.launch {
                        window.fetch(
                            input = "https://autocomms.bluepeak.cc/api/message", init = RequestInit(
                                method = "POST",
                                headers = Headers().apply {
                                    append("Content-Type", "application/json")
                                },
                                body = """{
                          "form": "clubmanager.cc/contact",
                          "email": "$email",
                          "content": "$message",
                          "name": "${name.ifBlank { "Anonymous" }}"
                        }""",
                                mode = RequestMode.CORS,
                                cache = RequestCache.NO_CACHE,
                                credentials = RequestCredentials.SAME_ORIGIN,
                                redirect = RequestRedirect.MANUAL,
                                referrerPolicy = "origin",
                                keepalive = true,
                            )
                        ).await()
                        sent = true
                        delay(5.seconds)
                        name = ""
                        email = ""
                        message = ""
                        sent = false
                    }
                },
                Modifier.fillMaxWidth(),
                enabled = !sent && name.isNotBlank() && email.isNotBlank() && message.isNotBlank()
            ) {
                if (sent) LucideCheck()
                else Text(Res.string.contact_form_submit)
            }
        }
    }

}